import React, { useEffect, useState } from 'react';

export default function VerifyMandateFrontend() {
  const params = new URLSearchParams(window.location.search);
  const status = params.get('status');
  const message = params.get('message');
  const [seconds, setseconds] = useState(10);

  // auto redirect only after a successful payment
  useEffect(() => {
    if (status !== 'success') return;
    const timer = setInterval(() => {
      setseconds((prev) => {
        if (prev <= 1) {
          clearInterval(timer);
          window.location.href = '/subscriptions';
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  if (status !== 'success') {
    return (
      <div className="container mt-5" style={{ maxWidth: '440px' }}>
        <div className="card shadow-sm p-4 text-center">
          <div className="mb-3">
            <span className="badge bg-danger">FAILED</span>
          </div>

          <h3 className="text-danger mb-3">Payment not completed</h3>
          <p className="text-muted">{message}</p>

          <button
            className="btn btn-primary mt-2 w-100"
            onClick={() => { window.location.href = '/subscriptions'; }}
          >
            Go to Subscriptions Now
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="container mt-5" style={{ maxWidth: '440px' }}>
      <div className="card shadow-sm p-4 text-center">
        <div className="mb-3">
          <span className="badge bg-success">SUCCESS</span>
        </div>

        <h3 className="text-success mb-3">Subscription Successful!</h3>
        <p className="text-muted">
          Your mandate has been authorized and your subscription is now active.
        </p>

        <p className="small text-secondary mt-3">
          Redirecting to subscriptions in <strong>{seconds}</strong> seconds...
        </p>

        <button
          className="btn btn-primary mt-2 w-100"
          onClick={() => { window.location.href = '/subscriptions'; }}
        >
          Go to Subscriptions Now
        </button>
      </div>
    </div>
  );
}
